import { Component, input, output, signal } from '@angular/core';
import { AdminInfraService } from 'app/admin/services/admin-infra.service';
import { Asset } from 'app/classes/asset';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';
import { Gateway } from 'app/classes/gateway';
import { Org } from 'app/classes/org';
import { Site } from 'app/classes/site';
import { User } from 'app/classes/user';
import { APIService } from 'app/shared/api.service';
import { ITrackingIssueEntityItem } from 'app/shared/issue-tracking.service';

@Component({
  selector: 'app-issue-tracking-entity-picker',
  standalone: false,
  templateUrl: './issue-tracking-entity-picker.component.html',
  styleUrl: './issue-tracking-entity-picker.component.css'
})
export class IssueTrackingEntityPickerComponent {

  org = input.required<Org>();

  entities = input<any>();
  onChanged = output<ITrackingIssueEntityItem>();
  isAdmin = this.apiService.isAdmin();
  tabIndex = signal<dialogType>('help');

  orgs: Org[];
  sites: Site[];
  gateways: Gateway[];
  users: User[];
  assets: Asset[];

  dataTableOrgs: DataTable;
  dataTableOrgsConfig: IDataClassConfig = {
    "id": { "valueType": "number", "title": "ID", "align": "right", "width": 50 },
    "logo": { "valueType": "image", "title": "", "align": "left", "dataFormat": "logo", "width": 40 },
    "title": { "valueType": "string", "title": "Org", "align": "left" },
    "siteCount": { "valueType": "number", "title": "sites", "align": "right", "width": 90 },
    "shortTitle": { "valueType": "string", "title": "Short title", "align": "left" },
    "type": { "valueType": "string", "title": "Type", "align": "left", "width": 90 },
    "createdAt": { "valueType": "date", "dataFormat": "date", "title": "Created", "align": "right", width: 90 },
    "isActive": { "valueType": "boolean", "title": "Active", "isHidden": true, "align": "center" },
  };

  dataTableSites: DataTable;
  dataTableSitesConfig: IDataClassConfig = {
    "id": { "valueType": "number", "title": "ID", "align": "right", "width": 50 },
    "title": { "valueType": "string", "title": "Site", "align": "left" },
    "addressTown": { "valueType": "string", "title": "Town", "align": "left" },
    "addressCounty": { "valueType": "string", "title": "County", "align": "left" },
    "addressPostcode": { "valueType": "string", "title": "Postcode", "align": "left", width: 100 },
    "createdAt": { "valueType": "date", "title": "Created", align: "left", dataFormat: "date", width: 100 },
    "gatewayCount": { "valueType": "number", "title": "Gateways", "align": "right", width: 90 },
    "isActive": { "valueType": "boolean", "title": "Active", "isHidden": true, "align": "center" },
  };

  dataTableGateways: DataTable;
  dataTableGatewaysConfig: IDataClassConfig = {
    "id": { "valueType": "string", "title": "ID", "align": "left", "width": 200 },
    "title": { "valueType": "string", "title": "Gateway", "align": "left" },
    "assetCount": { "valueType": "number", "title": "Assets", "align": "left", width: 90 },
    "createdAt": { "valueType": "date", "title": "Created", align: "left", dataFormat: "date", width: 100 },
    "isActive": { "valueType": "boolean", "title": "Active", "isHidden": true, "align": "center" },
  };

  dataTableUsers: DataTable;
  dataTableUsersConfig: IDataClassConfig = {
    "id": { "valueType": "number", "title": "ID", "align": "right", "width": 50 },
    "name": { "valueType": "string", "title": "name", "align": "left" },
    "email": { "valueType": "number", "title": "email", "align": "left", },
    "createdAt": { "valueType": "date", "title": "created", align: "left", dataFormat: "date" }
  };

  dataTableAssets: DataTable;
  dataTableAssetsConfig: IDataClassConfig = {
    "id": { "valueType": "string", "title": "ID", "align": "left", "width": 60 },
    "title": { "valueType": "string", "title": "Asset", "align": "left" },
    "gateway_id": { "valueType": "string", "title": "Gateway", "align": "left" },
    "createdAt": { "valueType": "date", "title": "Created", align: "left", dataFormat: "date", width: 100 }
  };

  constructor(private apiService: APIService, private adminInfraService: AdminInfraService) {
    this.isAdmin = apiService.isAdmin();
  }

  tabClick(tab: dialogType) {
    switch (tab) {
      case 'org':
        if (!this.orgs?.length && this.isAdmin) {
          this.apiService.getOrgs().then((res) => {
            this.orgs = res;
            this.dataTableOrgs = new DataTable({ data: this.orgs }, this.dataTableOrgsConfig);
          });
        }
        break;
      case 'site':
        if (!this.sites?.length) {
          this.adminInfraService.getSitesForOrg(this.org().id).then((res) => {
            this.sites = res.sites;
            if (this.sites.length) {
              this.dataTableSites = new DataTable({ data: this.sites }, this.dataTableSitesConfig);
            } else {
              this.apiService.toastWarn('No sites', '');
            }
          });
        }
        break;
      case 'building':
        break;
      case 'gateway':
        if (!this.gateways?.length) {
          this.adminInfraService.getGatewaysForOrg(this.org().id).then((res) => {
            this.gateways = res.gateways;
            if (this.gateways.length) {
              this.dataTableGateways = new DataTable({ data: this.gateways }, this.dataTableGatewaysConfig);
            } else {
              this.apiService.toastWarn('No gateways', '');
            }
          });
        }
        break;
      case 'asset':
        if (!this.assets?.length) {
          this.adminInfraService.getAssetsForOrg(this.org().id).then((res) => {
            this.assets = res.assets;
            this.dataTableAssets = new DataTable({ data: this.assets }, this.dataTableAssetsConfig);
          });
        }
        break;
        break;
      case 'user':
        // if (this.isAdmin) {
        this.adminInfraService.getUsersForOrg(this.org().id).then((res) => {
          this.users = res.users;
          this.dataTableUsers = new DataTable({ data: this.users }, this.dataTableUsersConfig);
        });
        // }
        break;
    }

    this.tabIndex.set(tab);
  }

  rowClick(tab: 'org' | 'site' | 'gateway' | 'user', obj: any) {
    this.onChanged.emit({ type: tab, obj });
  }
}

export type dialogType = 'org' | 'site' | 'building' | 'gateway' | 'asset' | 'user' | 'help';
